export default __webpack_public_path__ + "static/media/logOut.ead88920.png";